import styled from 'styled-components';
import { Colors, ColorValues, fixedBgToTextColor } from '../Style';

interface BadgeProps {
	className?: string;
	children?: React.ReactNode;
	color?: ColorValues;
	onClick?: () => void;
}

export default function Badge(props: BadgeProps) {
	const bgColor = props.color ? props.color : Colors.blue;
	const color = fixedBgToTextColor(bgColor);
	const className = props.className ? props.className : '';

	return (
		<>
			<Container onClick={props.onClick} className={`${className} badge`} bgColor={bgColor} color={color}>
				{props.children}
			</Container>
		</>
	);
}

const Container = styled.span<{ bgColor: string; color: string }>`
	background: ${(props) => props.bgColor};
	color: ${(props) => props.color};
`;
